module.exports = __webpack_public_path__ + "media/images/athletes/1466-972f3051cd726507f73f356874226d1c.png";